/**
 * footer-uqam.js
 */

// Import
import "./footer-uqam.scss";
import $ from 'jquery';

$(document).ready(function() {

});

